'use strict';

import Swiper from 'swiper';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

const SELECTOR_ROOT = '.js-project-image-slider';

const initSlider = (root) => {
  if (root.dataset.sliderInitialized === '1') {
    return;
  }

  const swiperElement = root.querySelector('.tc-website-project-image-slider__swiper');
  const nextElement = root.querySelector('.tc-website-project-image-slider__nav--next');
  const prevElement = root.querySelector('.tc-website-project-image-slider__nav--prev');

  if (!swiperElement) {
    return;
  }

  const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
  if (!slideCount) {
    return;
  }

  if (slideCount <= 3) {
    root.classList.add('is-nav-hidden-desktop');
  }

  const swiper = new Swiper(swiperElement, {
    loop: slideCount > 1,
    slidesPerView: 1,
    spaceBetween: 12,
    watchOverflow: false,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 14
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
  });

  if (prevElement) {
    prevElement.addEventListener('click', (event) => {
      event.preventDefault();
      swiper.slidePrev();
    });
  }

  if (nextElement) {
    nextElement.addEventListener('click', (event) => {
      event.preventDefault();
      swiper.slideNext();
    });
  }

  let isWheelSliding = false;
  swiperElement.addEventListener('wheel', (event) => {
    if (window.matchMedia('(min-width: 992px)').matches && slideCount <= 3) {
      return;
    }

    if (Math.abs(event.deltaY) < 5) {
      return;
    }

    event.preventDefault();
    if (isWheelSliding) {
      return;
    }

    isWheelSliding = true;
    if (event.deltaY > 0) {
      swiper.slideNext();
    } else {
      swiper.slidePrev();
    }

    window.setTimeout(() => {
      isWheelSliding = false;
    }, 350);
  }, { passive: false });

  const lightbox = new PhotoSwipeLightbox({
    gallery: root,
    children: 'a.tc-website-project-image-slider__link',
    pswpModule: () => import('photoswipe'),
    // Les vignettes sont en object-fit:cover (ratio ≠ image pleine taille) : l’animation
    // « zoom » depuis la miniature déforme puis corrige. Le fondu évite cet effet.
    showHideAnimationType: 'fade',
    zoomAnimationDuration: 0
  });
  lightbox.init();

  root.dataset.sliderInitialized = '1';
};

const init = () => {
  const sliders = document.querySelectorAll(SELECTOR_ROOT);
  if (!sliders.length) {
    return;
  }
  sliders.forEach(initSlider);
};

export default { init };
